import { useState } from 'react'

const useLocalStorage = <T>(
  key: string,
  defaultValue: T,
): [T, (value: T | ((val: T) => T)) => void, () => void] => {
  const [localStorageValue, setLocalStorageValue] = useState<T>(() => {
    try {
      const value = localStorage.getItem(key)

      if (value) {
        return JSON.parse(value) as T
      } else {
        localStorage.setItem(key, JSON.stringify(defaultValue))
        return defaultValue
      }
    } catch (error) {
      localStorage.setItem(key, JSON.stringify(defaultValue))
      return defaultValue
    }
  })

  //set
  const setLocalStorageStateValue = (valueOrFn: T | ((val: T) => T)) => {
    let newValue: T
    if (typeof valueOrFn === 'function') {
      const fn = valueOrFn as (val: T) => T
      newValue = fn(localStorageValue)
    } else {
      newValue = valueOrFn
    }
    localStorage.setItem(key, JSON.stringify(newValue))
    setLocalStorageValue(newValue)
  }

  //remove
  const removeLocalStorageValue = () => {
    localStorage.removeItem(key)
    setLocalStorageValue(defaultValue) // Optional: Reset to default value
  }

  return [localStorageValue, setLocalStorageStateValue, removeLocalStorageValue]
}

export default useLocalStorage
